<template>
    <div class="TTL-el-form-search-regular">
        <el-form inline="true">
            <el-form-item>
                <wcinput :option="{placeholder:'请输入记录类型名称',clearable:true,ischange:true,isinput:true,iskeydown:true}" 
                    :value="param.key"
                    @finish="(val)=> {
                        if(val.type=='input') {param.key=val.value;param.ischange=true;}
                        if(val.type=='change') {param.key=val.value;param.ischange=true;}
                        if(val.type=='keydown') GetTypeList();
                    }"
                />
            </el-form-item>
            <el-form-item>
                <wcbutton :option="{title:'搜索'}" @finish="GetTypeList()" />
            </el-form-item>
            <el-form-item>
                <wcbutton :option="{title:'新增类型'}" @finish="AddRecordType()" />    
            </el-form-item>
        </el-form>
    </div>

    <div class="TTL-table top20" id="table-record-type-obj">
        <el-table :data="typelists" stripe="true" empty-text="" ref="pet" @selection-change="selecttable">
            <template v-slot:empty><el-empty description="暂无数据" /></template>
            <el-table-column type="expand" >
                <template #default="scope">
                    <el-table :data="scope.row.child" stripe="true" empty-text="">
                        <template v-slot:empty><el-empty description="暂无数据" /></template>
                        <el-table-column label="类型" align="center">
                            <template #default="scope">
                                <wcimage :value="scope.row.icon" :option="{size:'middle'}" />
                            </template>
                        </el-table-column>
                        <el-table-column prop="typename" label="类型名称" align="center"/>
                        <el-table-column label="操作" align="center">
                            <template #default="tscope">
                                <div class="TTL-btn-list">
                                <wcbutton :option="{title:'编辑'}" @finish="EditType(tscope.row.id)" />
                                <wcbutton :option="{title:'删除',type:'del'}" @finish="DelType(tscope.row.id)" class="left10" />
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
            </el-table-column>
            <el-table-column label="类型图" align="center">
                <template #default="scope">
                    <wcimage :value="scope.row.icon" :option="{size:'middle'}" />
                </template>
            </el-table-column>
            <el-table-column prop="typename" label="类型名称" align="center"/>
            <el-table-column label="操作" align="center">
                <template #default="scope">
                    <div class="TTL-btn-list">
                    <wcbutton :option="{title:'编辑'}" @finish="EditType(scope.row.id)" />
                    <wcbutton :option="{title:'删除',type:'del'}" @finish="DelType(scope.row.id)" class="left10" />
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
    <div class="TTL-page-box top20">
        <div class="TTL-page-box-in">
            <div class="TTL-page TTL-page-right">
                <wcpage 
                    :row="param.rows" 
                    :p="param.p" 
                    :rollpage="param.rollpage" 
                    @finish="(val)=> {
                        param.p=val.p;
                        param.rollpage=val.rollpage;
                        GetTypeList();
                    }"
                />
            </div>
        </div>
    </div>

</template>

<script>
import INTERFACE_MODEL_RECORD from '@/Interface/Record/Record';
export default {
    components:{},
    data() {
        return {
            param: {
                key:'',
                ischange:false,
                p:1,
                rollpage:10,
                rows:0,
            },
            typelists:[],

        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {


        /** 修改页面显示标签信息 **/
        ChangePageLabel() {
            
        },


        /** 页数初始化 **/
        OnloadMethod() {
            this.GetTypeList(); //获取类型列表
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {           //组件已存在，同级兄弟元素调用时产生的操作
                this.GetTypeList();    //获取类型列表
            }else if(data.reload) {    //浏览器重新刷新时执行的操作
                
            }else {
                
            }
        },


        /** 删除记录类型 **/
        DelType(id) {
            INTERFACE_MODEL_RECORD.DEL_RECORD_TYPE({id:id}).then((res) => {
                 if(res.status > 0) return false;
                 this.GetTypeList();
            });
        },


        /** 编辑记录类型 **/
        EditType(id) {
            var navinfo={name:'编辑记录类型',labelentry:'EditRecordType',components:'EditRecordType',isshow:false};
            var data={Method:'',delcomponent:'',ids:id};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },


        ///////////////////////////////////////////////////////
        //////////////////////////////////////////////////////
        //基础数据操作

        //获取类型信息列表
        GetTypeList() {
            if(this.param.ischange) {
                this.param.p=1;
                this.param.ischange=false;
            }

            //loading等待动画加载
            var obj=document.getElementById("table-record-type-obj");
            this.$loading.openloading(obj);
            INTERFACE_MODEL_RECORD.GET_RECORD_TYPE_LIST(this.param).then((res) => {
                 if(res.status > 0) return false;
                 this.$loading.closeloading(obj);
                 this.param.rows=res.data.count;
                 this.typelists=res.data.list;
            });
        },


        //新增记录类型
        AddRecordType() {
            var navinfo={name:'新增记录类型',labelentry:'AddRecordType',components:'AddRecordType',isshow:false};
            var data={Method:'',delcomponent:''};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },

        //基础数据操作
        ///////////////////////////////////////////////////////
        //////////////////////////////////////////////////////


    },
}
</script>
<style scoped>
.TTL-select-infos {display:inline-flex;align-items: center;}
.TTL-select-infos span {margin-left:10px;}
.TTL-pet-image {position: relative;display: inline-block;}
.TTL-image-box-sex {width:20px;height: 20px;position:absolute;right:0;top:0;margin-right:-5px;margin-top:-5px;border-radius: 50%;background:#ffffff;}
.TTL-btn-list {display:inline-flex;}
</style>